import React from 'react'

interface IProps {
  label: string
  value: React.ReactNode
  fullWidth?: boolean
  className?: string
  valueClassName?: string
}

export const FormFieldLabel: React.FC<IProps> = ({ label, value, fullWidth = false, className, valueClassName }) => {
  const itemClassName = ['read-only-item', fullWidth ? 'full-width' : '', className || ''].filter(Boolean).join(' ')
  const readOnlyValueClassName = ['read-only-value', valueClassName || ''].filter(Boolean).join(' ')

  return (
    <div className={itemClassName}>
      <span className="read-only-label">{label}:</span>
      <span className={readOnlyValueClassName}>{value}</span>
    </div>
  )
}
